import axios from 'axios';
import * as qs from 'app/lib/helperjs';
import {
    DATA_FORM_EVENT_NAME,
    preventResendingForm, alert
} from './formDataHandler';

export const RemindPasswordForm = () => {
    const remindPasswordForm = qs.querySelector('[data-form="remind_password"]');
    if (!remindPasswordForm) {
        return;
    }

    document.addEventListener(DATA_FORM_EVENT_NAME, function listener(evt) {
        const {data, url, form} = evt.detail;

        if (!remindPasswordForm.isEqualNode(form)) {
            return;
        }

        axios.post(url, data)
            .then(() => alert('success'))
            .then(() => preventResendingForm(form))
            .then(() => document.removeEventListener(DATA_FORM_EVENT_NAME, listener, true))
            .catch(() => alert('failure'));
    }, true);
};
